import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import {
  AccountUser,
  CreateIssueRequest,
  IssueDescriptionRequest,
  IssueDescriptionResponse,
  IssueIdName,
} from '../model/issue.model'
import { ReconInsightService } from './recon-insight.service'

export const RECON_INSIGHT_URL = `helios-breaks/reconInsight`

@Injectable({
  providedIn: 'root',
})
export class HttpReconInsightService extends ReconInsightService {
  private readonly issueTypes: Observable<IssueIdName[]>
  private readonly issueSources: Observable<IssueIdName[]>
  private readonly priorities: Observable<IssueIdName[]>

  constructor(private readonly http: HttpClient) {
    super()
    this.issueTypes = this.http.get<IssueIdName[]>(
      `${RECON_INSIGHT_URL}/issueType`,
    )
    this.issueSources = this.http.get<IssueIdName[]>(
      `${RECON_INSIGHT_URL}/issueSource`,
    )
    this.priorities = this.http.get<IssueIdName[]>(
      `${RECON_INSIGHT_URL}/issuePriority`,
    )
  }

  createReconInsightIssue(
    createIssueRequest: CreateIssueRequest,
  ): Observable<number> {
    return this.http.post<number>(`${RECON_INSIGHT_URL}`, createIssueRequest)
  }

  addAttachment(
    issueId: number,
    attachmentName: string,
    file: File,
  ): Observable<HttpResponse<void>> {
    const params = { issueId: issueId, attachmentName: attachmentName }
    const formData = new FormData()
    formData.append('attachment', file, file.name)
    return this.http.post<void>(`${RECON_INSIGHT_URL}/attachment`, formData, {
      params: params,
      observe: 'response',
    })
  }

  getReconInsightIssueTypes(): Observable<IssueIdName[]> {
    return this.issueTypes
  }

  getReconInsightIssueSources(): Observable<IssueIdName[]> {
    return this.issueSources
  }

  getReconInsightIssuePriorities(): Observable<IssueIdName[]> {
    return this.priorities
  }

  getReconInsightAccountUsers(accountId: number): Observable<AccountUser[]> {
    const params = { accountId: accountId }
    return this.http.get<AccountUser[]>(`${RECON_INSIGHT_URL}/accountUsers`, {
      params: params,
    })
  }

  getReconInsightIssueDescription(
    request: IssueDescriptionRequest,
  ): Observable<IssueDescriptionResponse> {
    return this.http.post<IssueDescriptionResponse>(
      `${RECON_INSIGHT_URL}/issue/description`,
      request,
      { responseType: 'json' },
    )
  }
}
